import * as GroupType from 'constants/GroupType';

const BEACH_VOLLEYBALL_GROUP_MAP = {};

BEACH_VOLLEYBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
BEACH_VOLLEYBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
BEACH_VOLLEYBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
BEACH_VOLLEYBALL_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
BEACH_VOLLEYBALL_GROUP_MAP[4] = GroupType.FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
BEACH_VOLLEYBALL_GROUP_MAP[5] = GroupType.FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
BEACH_VOLLEYBALL_GROUP_MAP[6] = GroupType.SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
BEACH_VOLLEYBALL_GROUP_MAP[7] = GroupType.SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;

export default BEACH_VOLLEYBALL_GROUP_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/BeachVolleyball/GroupMap.js